export default __webpack_public_path__ + "static/media/close.82ec0c16.svg";